import type { IconType } from '@icons-pack/react-simple-icons';
import {
  SiAcura,
  SiAstonmartin,
  SiAudi,
  SiBentley,
  SiBmw,
  SiBugatti,
  SiCadillac,
  SiChevrolet,
  SiChrysler,
  SiCitroen,
  SiDacia,
  SiFerrari,
  SiFiat,
  SiFord,
  SiHonda,
  SiHyundai,
  SiInfiniti,
  SiJeep,
  SiKia,
  SiLada,
  SiLamborghini,
  SiMahindra,
  SiMaserati,
  SiMazda,
  SiMclaren,
  SiMg,
  SiMini,
  SiMitsubishi,
  SiNissan,
  SiOpel,
  SiPeugeot,
  SiPolestar,
  SiPorsche,
  SiProton,
  SiRenault,
  SiRollsroyce,
  SiSeat,
  SiSkoda,
  SiSmart,
  SiSubaru,
  SiSuzuki,
  SiTesla,
  SiToyota,
  SiVolkswagen,
  SiVolvo,
} from '@icons-pack/react-simple-icons';

import { findBrandKey } from './carKeys';

/**
 * Simple Icons only covers a subset of car brands (notably missing Mercedes-Benz, Land Rover,
 * Lexus, Alfa Romeo, Genesis, Lincoln...) - EntityCard falls back to its existing letter avatar
 * for any brand key not present here.
 */
const BRAND_ICONS: { [brandKey: string]: IconType } = {
  ACURA: SiAcura,
  ASTON_MARTIN: SiAstonmartin,
  AUDI: SiAudi,
  BENTLEY: SiBentley,
  BMW: SiBmw,
  BUGATTI: SiBugatti,
  CADILLAC: SiCadillac,
  CHEVROLET: SiChevrolet,
  CHRYSLER: SiChrysler,
  CITROEN: SiCitroen,
  DACIA: SiDacia,
  FERRARI: SiFerrari,
  FIAT: SiFiat,
  FORD: SiFord,
  HONDA: SiHonda,
  HYUNDAI: SiHyundai,
  INFINITI: SiInfiniti,
  JEEP: SiJeep,
  KIA: SiKia,
  LADA: SiLada,
  LAMBORGHINI: SiLamborghini,
  MAHINDRA: SiMahindra,
  MASERATI: SiMaserati,
  MAZDA: SiMazda,
  MCLAREN: SiMclaren,
  MG: SiMg,
  MINI: SiMini,
  MITSUBISHI: SiMitsubishi,
  NISSAN: SiNissan,
  OPEL: SiOpel,
  PEUGEOT: SiPeugeot,
  POLESTAR: SiPolestar,
  PORSCHE: SiPorsche,
  PROTON: SiProton,
  RENAULT: SiRenault,
  ROLLS_ROYCE: SiRollsroyce,
  SEAT: SiSeat,
  SKODA: SiSkoda,
  SMART: SiSmart,
  SUBARU: SiSubaru,
  SUZUKI: SiSuzuki,
  TESLA: SiTesla,
  TOYOTA: SiToyota,
  VW: SiVolkswagen,
  VOLVO: SiVolvo,
};

/** Looks up a brand's official logo by its display name (e.g. "Mercedes-Benz"), if we have one. */
export function getBrandIcon(displayName: string): IconType | undefined {
  const key = findBrandKey(displayName);
  return key ? BRAND_ICONS[key] : undefined;
}
